/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.sales.documents.rpc.SalesDocumentsGDPRService
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const getConsentFormWrapRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsGDPRService',
  rpcName: 'getConsentFormWrap',
  auth: 'app',
  fingerprint: 'ffznQ9qp3PVllPykvWpwuCZvnTu4aPTm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getGdprWrapRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsGDPRService',
  rpcName: 'getGdprWrap',
  auth: 'app',
  fingerprint: 'mNKFeLd1J76lV0_Krz8vIyZvnTu4aPTm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const submitViewerFormRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsGDPRService',
  rpcName: 'submitViewerForm',
  auth: 'app',
  fingerprint: '4w0CZV31Z0SOUe2e_r4XmSZvnTu4aPTm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateSettingsRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsGDPRService',
  rpcName: 'updateSettings',
  auth: 'app',
  fingerprint: 'FjaMpbgqLxelV0_Krz8vIyZvnTu4aPTm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};